import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {gpCommon} from "../GasPass";


const ControllerNotFound = ({ data }) => {

    return(
        <div className="notFound">
            <div>{gpCommon.getString( data['code'], '' )}</div>
            <div>{gpCommon.getString( data['description'], '' )}</div>
        </div>
    );

}
ControllerNotFound.propTypes = {
    data: PropTypes.object
};
export default ControllerNotFound;
